import { useQueries } from '@tanstack/react-query';

import { getOrdersTotal } from '../../common/api/clients/gateway.api';
import { queries } from '../../common/api/queryKeys/queries';

import { OrderTab } from './orderTabsHelper';
import { mapQuickFilterToTab } from './quickfilter/quickFilterMappingHelper';
import { PartialQuickFilterTotals, QuickFilterValue } from './quickfilter/QuickFilterValueTypes';
import { resolveOrderFilterStates } from './resolveOrderFilterStates';

interface UseOrderQuickFilterTotalsParams {
    searchQuery?: string;
    customerIds?: string[];
    supplierIds?: string[];
    tab: OrderTab;
}

export const useOrderQuickFilterTotals = ({
    searchQuery,
    customerIds,
    supplierIds,
    tab,
}: UseOrderQuickFilterTotalsParams): PartialQuickFilterTotals => {
    const quickFilterValues = mapQuickFilterToTab(tab);

    // Create queries for each quick filter value using the unified query structure
    const quickFilterQueries = useQueries({
        queries:
            quickFilterValues?.map((quickFilter: QuickFilterValue) => ({
                queryKey: queries.orders.quickFilterTotals({
                    searchQuery,
                    customerIds,
                    supplierIds,
                    tab,
                    quickFilter,
                }).queryKey,
                queryFn: async () => {
                    const { offerStates, states, approvalRequestStates } = resolveOrderFilterStates(tab, quickFilter);

                    const ordersTotalMessage = await getOrdersTotal({
                        searchQuery,
                        customerIds,
                        supplierIds,
                        offerStates,
                        states,
                        approvalRequestStates,
                    });

                    return ordersTotalMessage.count;
                },
            })) || [],
    });

    const data: PartialQuickFilterTotals = {};
    quickFilterValues?.forEach((quickFilter, index) => {
        const query = quickFilterQueries[index];
        data[quickFilter] = query.data || 0;
    });

    return data;
};
